export const application = 'gwu-dev';
export const apiURL = 'http://localhost:5200/gwu/api';
export const useLocalLanguage = true;



// WEBPACK FOOTER //
// ./src/config/dev.js